import axios from 'axios';

const isDev = process.env.NODE_ENV === 'development';
const configuredBase = process.env.REACT_APP_API_BASE || '';

const api = axios.create({
  // In dev, prefer CRA proxy (package.json "proxy") to avoid CORS/CORP issues.
  // In prod, default to same-origin `/api/...` (nginx routes to the API) unless REACT_APP_API_BASE is set.
  baseURL: isDev ? (configuredBase || '') : configuredBase,
    withCredentials: false,
});


// Attach JWT automatically
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});


// Basic error surface; expand for refresh-token flow later
api.interceptors.response.use(
    (res) => res,
    (err) => {
    const status = err?.response?.status;
    if (status === 401) {
        // Token invalid/expired → logout locally
        localStorage.removeItem('token');
    }
        return Promise.reject(err);
    }
);


export default api;